import isMobilejs from 'ismobilejs';

export const isPhone = isMobilejs(window.navigator).phone;
